import React, { useRef, forwardRef } from 'react';
import {
    Card,
    CardContent,
    Dialog,
    makeStyles,
    Slide,
    Theme,
} from '@material-ui/core';
import { IModal } from './types';
import { TransitionProps } from '@material-ui/core/transitions';
import { ModalHeader } from './ModalHeader';
import { EvaluationForm } from './Form';
import useLead from 'src/hooks/useLead';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        overflow: 'scroll',
    },
}));

const Transition = forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

export const Modal = ({ open, setOpen, isComplete, ...props }: IModal) => {
    const classes = useStyles();
    const forwardedRef = useRef();
    const { lead } = useLead();

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            ref={forwardedRef}
            TransitionComponent={Transition}
            {...props}
        >
            <ModalHeader
                setOpen={setOpen}
                lead={lead}
                isComplete={isComplete}
            />
            <Card elevation={0} className={classes.root}>
                <CardContent>
                    <EvaluationForm
                        lead={lead}
                        setOpen={setOpen}
                        isComplete={isComplete}
                    />
                </CardContent>
            </Card>
        </Dialog>
    );
};
